<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="求职简历-已接收">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-button plain hairline type="primary" icon="down" size="small"
                      @click="download">下载简历</van-button>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :row="3" :loading="loading" :style="{ paddingTop: '16px' }">

        <van-row v-show="resumeInfo['jobList'].length !== 0">
          <van-col class="resume-item">
            <van-icon name="like-o" color="#1989fa" />
            <span style="padding-left: 6px">拟邀职位</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card" v-show="resumeInfo['jobList'].length !== 0">
          <van-cell v-for="data in resumeInfo['jobList']" :key="data"
                    :title="data['title']"  v-show="data['isPass'] === '1'">
            <template #value>
              <van-row justify="end">
                <span>{{ data['company'] }}</span>
              </van-row>
              <van-row justify="end">
                <span>投递时间：{{ parseTimeStr(data['applyTime']) }}</span>
              </van-row>
            </template>
          </van-cell>
        </van-cell-group>

        <van-row justify="space-between">
          <van-col class="resume-item">
            <van-icon name="edit" color="#1989fa" />
            <span style="padding-left: 6px">创建时间</span>
          </van-col>
          <van-col class="resume-item">
            <van-row justify="end">
              <span style="font-size: 15px">{{parseTimeStr(resumeInfo['createtime'])}}</span>
            </van-row>
          </van-col>
        </van-row>

        <van-row justify="space-between">
          <van-col class="resume-item">
            <van-icon name="sign" color="#1989fa" />
            <span style="padding-left: 6px">接收时间</span>
          </van-col>
          <van-col class="resume-item">
            <van-row justify="end">
              <span style="font-size: 15px">{{parseTimeStr(resumeInfo['acceptTime'])}}</span>
            </van-row>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="resume-item">
            <van-icon name="user-o" color="#1989fa" />
            <span style="padding-left: 6px">基本信息</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card">
          <van-cell title="姓名" :value="resumeInfo['name']"/>
          <van-cell title="性别" :value="resumeInfo['gender']"/>
          <van-cell title="手机号">
            <a :href="'tel:' + resumeInfo['phone']" class="phone">
              <van-icon name="phone-o" />
              <span>{{ resumeInfo['phone'] }}</span>
            </a>
          </van-cell>
          <van-cell title="户籍所在地" :value="resumeInfo['nativePlace']" v-if="resumeInfo['nativePlace']"/>
          <van-cell title="电子邮箱" :value="resumeInfo['email']" v-if="resumeInfo['email']"/>
          <van-cell title="出生日期" :value="resumeInfo['birthday']" v-if="resumeInfo['birthday']"/>
          <van-cell title="政治面貌" :value="resumeInfo['political']" v-if="resumeInfo['political']"/>
          <van-cell title="工作状态" :value="resumeInfo['status']" v-if="resumeInfo['status']"/>
          <van-cell title="目前所在地" :value="resumeInfo['city']" v-if="resumeInfo['city']"/>
          <van-cell title="期望薪资(K)" :value="resumeInfo['salary']" v-if="resumeInfo['salary']"/>
        </van-cell-group>

        <van-row>
          <van-col class="resume-item">
            <van-icon name="hotel-o" color="#1989fa" />
            <span style="padding-left: 6px">教育经历</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card"
                        v-for="(experience, index) in JSON.parse(resumeInfo['educationExperiences'])"
                        :key="index">
          <van-cell title="学校名称" :value="experience['school']"/>
          <van-cell title="专业名称" :value="experience['major']"/>
          <van-cell title="学历" :value="experience['qualification']"/>
          <van-cell title="学位" :value="experience['degree']"/>
          <van-cell title="开始日期" :value="experience['startDate']"/>
          <van-cell title="结束日期" :value="experience['endDate']"/>
        </van-cell-group>

        <van-row v-show="initExperiences('workExperiences')">
          <van-col class="resume-item">
            <van-icon name="hotel-o" color="#1989fa" />
            <span style="padding-left: 6px">工作经历</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card" v-show="initExperience('workExperiences', index)"
                        v-for="(experience, index) in JSON.parse(resumeInfo['workExperiences'])"
                        :key="index">
          <van-cell title="公司名称" :value="experience['company']" v-if="experience['company']"/>
          <van-cell title="岗位名称" :value="experience['position']" v-if="experience['position']"/>
          <van-cell title="开始日期" :value="experience['startDate']" v-if="experience['startDate']"/>
          <van-cell title="结束日期" :value="experience['endDate']" v-if="experience['endDate']"/>
          <van-cell title="工作内容" v-if="experience['description']">
            <template #label>
              <span v-html="linefeed(experience['description'])"/>
            </template>
          </van-cell>
        </van-cell-group>

        <van-row v-show="initExperiences('projectExperiences')">
          <van-col class="resume-item">
            <van-icon name="hotel-o" color="#1989fa" />
            <span style="padding-left: 6px">项目经历</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card" v-show="initExperience('projectExperiences', index)"
                        v-for="(experience, index) in JSON.parse(resumeInfo['projectExperiences'])"
                        :key="index">
          <van-cell title="项目名称" :value="experience['name']" v-if="experience['name']"/>
          <van-cell title="担任角色" :value="experience['role']" v-if="experience['role']"/>
          <van-cell title="项目描述" v-if="experience['description']">
            <template #label>
              <span v-html="linefeed(experience['description'])"/>
            </template>
          </van-cell>
        </van-cell-group>

        <van-row v-show="resumeInfo['selfAssessment'] || resumeInfo['careerPlan']">
          <van-col class="resume-item">
            <van-icon name="good-job-o" color="#1989fa" />
            <span style="padding-left: 6px">评价与规划</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-card" v-show="resumeInfo['selfAssessment'] || resumeInfo['careerPlan']">
          <van-cell title="自我评价" v-if="resumeInfo['selfAssessment']">
            <template #label>
              <span v-html="linefeed(resumeInfo['selfAssessment'])"/>
            </template>
          </van-cell>
          <van-cell title="职业规划" v-if="resumeInfo['careerPlan']">
            <template #label>
              <span v-html="linefeed(resumeInfo['careerPlan'])"/>
            </template>
          </van-cell>
        </van-cell-group>

        <van-row v-show="resumeInfo['electronic']">
          <van-col class="resume-item">
            <van-icon name="newspaper-o" color="#1989fa" />
            <span style="padding-left: 6px">电子版简历</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-picture" v-if="resumeInfo['electronic']">
          <van-uploader v-model="electronic" @click-preview="downloadOne"
                        :deletable="false" :show-upload="false" />
        </van-cell-group>

        <van-row v-show="resumeInfo['photo']">
          <van-col class="resume-item">
            <van-icon name="smile-o" color="#1989fa" />
            <span style="padding-left: 6px">登记照</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-picture" v-if="resumeInfo['photo']">
          <van-uploader v-model="photo"
                        :deletable="false" :show-upload="false" />
        </van-cell-group>

        <van-row v-show="resumeInfo['certificate']">
          <van-col class="resume-item">
            <van-icon name="award-o" color="#1989fa" />
            <span style="padding-left: 6px">资格证书</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="resume-picture" v-if="resumeInfo['certificate']">
          <van-uploader v-model="certificate" @click-preview="downloadOne"
                        :deletable="false" :show-upload="false" />
        </van-cell-group>

        <van-row justify="center">
          <van-button class="resume-button" type="primary" round block icon="like-o" @click="isShowDialogResume = true"
                      :disabled="resumeInfo['flag'] === 1" v-if="isInterview === 0">接收简历</van-button>
          <van-button class="resume-button" type="primary" round block icon="guide-o" @click="isShowDialogInterview = true"
                      v-if="isInterview === 1">邀请面试</van-button>
        </van-row>

        <van-row justify="center" v-if="isInterview === 2 && resumeInfo['flag'] === 1">
          <van-space :size="20">
            <van-button class="resume-button" type="success" plain round block icon="success" @click="acceptInterview">面试通过</van-button>
            <van-button class="resume-button" type="danger" plain round block icon="cross" @click="refuseInterview">面试失败</van-button>
          </van-space>
        </van-row>

      </van-skeleton>

      <van-dialog v-model:show="isShowDialogResume" title="接收简历" show-cancel-button :before-close="beforeCloseResume">
        <van-form ref="receiveResumeForm">
          <van-field v-model="jobName" name="jobName" label="招收职位" placeholder="请选择"
                     readonly is-link @click="isShowJob = true"
                     type="textarea" autosize
                     :rules="[{ required: true, message: '招收职位不能为空' }]" required />
          <van-popup v-model:show="isShowJob" round position="bottom">
            <van-picker title="选择职位" :columns="jobOption" @cancel="isShowJob = false" @confirm="setJob"/>
          </van-popup>
        </van-form>
      </van-dialog>

      <van-dialog v-model:show="isShowDialogInterview" title="邀请面试" show-cancel-button :before-close="beforeCloseInterview">
        <van-form ref="interviewForm">
          <van-field v-model="interviewDate" name="interviewDate" label="面试日期" placeholder="请选择"
                     readonly is-link @click="isShowDate = true"
                     :rules="[{ required: true, message: '面试日期不能为空' }]" required />
          <van-popup v-model:show="isShowDate" round position="bottom">
            <van-date-picker title="选择年月日" v-model="currentDate"
                             :min-date="minDate" :max-date="maxDate"
                             @cancel="isShowDate = false" @confirm="setInterviewDate"/>
          </van-popup>

          <van-field v-model="interviewTime" name="interviewTime" label="面试时间" placeholder="请选择"
                     readonly is-link @click="isShowTime = true"
                     :rules="[{ required: true, message: '面试时间不能为空' }]" required />
          <van-popup v-model:show="isShowTime" round position="bottom">
            <van-time-picker title="选择日期" v-model="currentTime"
                             @cancel="isShowTime = false" @confirm="setInterviewTime"/>
          </van-popup>
        </van-form>
      </van-dialog>
    </div>
  </div>

</template>

<script>

import {parseTime, selectDictText} from "@/api/common";
import {
  downloadResume,
  feedbackInterview,
  getResumeHits,
  getUserJobOption,
  hitResume,
  interview,
  isInterview,
  receiveResume
} from "@/api";
import {ref} from "vue";
import {showNotify} from "vant";

export default {
  name: "ResumeAcceptInfo",
  data() {
    return {
      loading: true,
      resumeInfo: {},
      hits: undefined,
      isInterview: 0,

      isShowDialogResume: false,
      isShowDialogInterview: false,

      interviewDate: '',
      isShowDate: false,
      currentDate: undefined,
      minDate: undefined,
      maxDate: undefined,

      interviewTime: '',
      isShowTime: false,
      currentTime: undefined,

      jobId: '',
      isShowJob: false,
      jobName: '',
      jobOption: [],

      photo: [],
      certificate: [],
      electronic: [],

      userId: '',
      resumeId: '',
    }
  },
  mounted() {
    this.loading = true;
    this.resumeId = this.$route.params['resumeId'];
    this.reset();
  },
  methods: {
    reset() {
      this.closeDialog();
      let resumeInfo = window.sessionStorage.getItem('resumeInfo');
      if (resumeInfo !== null && resumeInfo !== undefined && resumeInfo !== 'undefined') {
        this.resumeInfo = JSON.parse(resumeInfo);

        if (this.resumeInfo['photo'] === null || this.resumeInfo['photo'] === undefined) {
          this.photo = [];
        } else {
          this.photo = JSON.parse(this.resumeInfo['photo']);
        }

        if (this.resumeInfo['certificate'] === null || this.resumeInfo['certificate'] === undefined) {
          this.certificate = [];
        } else {
          this.certificate = [];
          let certificate = JSON.parse(this.resumeInfo['certificate']);
          for (let i = 0; i < certificate.length; i++) {
            let item = {};
            item['url'] = certificate[i]['url'];
            item['file'] = new File([], certificate[i]['name'], {});
            this.certificate.push(item);
          }
        }

        if (this.resumeInfo['electronic'] === null || this.resumeInfo['electronic'] === undefined) {
          this.electronic = [];
        } else {
          this.electronic = [];
          let electronic = JSON.parse(this.resumeInfo['electronic']);
          for (let i = 0; i < electronic.length; i++) {
            let item = {};
            item['url'] = electronic[i]['url'];
            item['file'] = new File([], electronic[i]['name'], {});
            this.electronic.push(item);
          }
        }

        this.userId = this.resumeInfo['userId'];

        hitResume('resumeId=' + this.resumeId).then(() => {
          getResumeHits(this.resumeId).then((res) => {
            if (res.code === 200) {
              this.hits = res.data;
            } else {
              this.hits = 0;
            }
            this.loading = false;
          });
        });
        getUserJobOption('userId=' + this.resumeInfo['userId']).then((res) => {
          if (res.code === 200) {
            this.jobOption = res.data;
          }
        });
        this.loading = true;
        isInterview('resumeId=' + this.resumeId).then((res) => {
          if (res.code === 200) {
            this.isInterview = res.data;
            console.log('isInterview:' + this.isInterview);
          } else {
            this.isInterview = 0;
          }
          this.loading = false;
        });
      }
    },
    goBack() {
      window.history.back();
    },
    linefeed(content) {
      return content.replaceAll('\n', '<br>');
    },
    initExperiences(key) {
      let experienceJson = JSON.parse(this.resumeInfo[key]);
      for (let i = 0; i < experienceJson.length; i++) {
        let experience = experienceJson[i];
        for (let item in experience) {
          if (experience[item] !== '') {
            return true;
          }
        }
      }
      return false;
    },
    initExperience(key, i) {
      let experienceJson = JSON.parse(this.resumeInfo[key]);
      let experience = experienceJson[i];
      for (let item in experience) {
        if (experience[item] !== '') {
          return true;
        }
      }
      return false;
    },
    parseTimeStr(time, pattern) {
      return parseTime(time, pattern);
    },
    closeDialog() {
      this.isShowDialogResume = false;
      this.isShowDialogInterview = false;
      this.interviewDate = '';
      this.interviewTime = '';
      this.jobId = '';
      this.jobName = '';
      this.currentDate = undefined;
      this.minDate = new Date();
      this.maxDate = new Date();
      this.maxDate.setDate(this.minDate.getDate() + 90);
      this.currentTime = ref(['09', '00']);
    },
    setInterviewDate() {
      this.interviewDate = this.currentDate[0] + '-' + this.currentDate[1] + '-' + this.currentDate[2];
      this.isShowDate = false;
      this.currentDate = undefined;
    },
    setInterviewTime() {
      this.interviewTime = this.currentTime[0] + ':' + this.currentTime[1] + ':00'
      this.isShowTime = false;
      this.currentTime = undefined;
    },
    setJob(option) {
      let values = option.selectedValues;
      this.jobId = values[0];
      this.jobName = selectDictText(this.jobOption, values[0]);
      this.isShowJob = false;
    },
    beforeCloseInterview(action) {
      if (action === "confirm") {
        this.$refs.interviewForm.validate().then(() => {
          //调用接口
          this.handleInterview();
          this.closeDialog();
        }).catch(() => {
          this.closeDialog();
        });
      } else {
        this.closeDialog();
      }
    },
    handleInterview() {
      let interviewTime = this.interviewDate + ' ' + this.interviewTime;
      //邀请面试
      interview('resumeId=' + this.resumeId + '&interviewTime=' + interviewTime).then((res) => {
        if (res.code === 200) {
          this.reset();
          //成功
          showNotify({ type: 'success', message: '邀请面试成功！', position: 'bottom' });
          this.isShowDialogInterview = false;
        } else if (res.code === 500) {
          showNotify({ type: 'danger', message: res.msg, position: 'bottom' });
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    beforeCloseResume(action) {
      if (action === "confirm") {
        this.$refs.receiveResumeForm.validate().then(() => {
          //调用接口
          this.handleReceiveResume();
          this.closeDialog();
        }).catch(() => {
          this.closeDialog();
        });
      } else {
        this.closeDialog();
      }
    },
    handleReceiveResume() {
      //接收简历
      receiveResume('resumeId=' + this.resumeId + '&jobId=' + this.jobId).then((res) => {
        if (res.code === 200) {
          this.reset();
          //成功
          showNotify({ type: 'success', message: '接收简历成功！', position: 'bottom' });
          this.isShowDialogResume = false;
        } else if (res.code === 500) {
          showNotify({ type: 'danger', message: res.msg, position: 'bottom' });
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    acceptInterview() {
      feedbackInterview('flag=2&resumeId=' + this.resumeId).then((res) => {
        if (res.code === 200) {
          this.reset();
          //成功
          showNotify({ type: 'success', message: '接受成功！', position: 'bottom' });
        } else if (res.code === 500) {
          showNotify({ type: 'danger', message: res.msg, position: 'bottom' });
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    refuseInterview() {
      feedbackInterview('flag=-1&resumeId=' + this.resumeId).then((res) => {
        if (res.code === 200) {
          this.reset();
          //成功
          showNotify({ type: 'success', message: '拒绝成功！', position: 'bottom' });
        } else if (res.code === 500) {
          showNotify({ type: 'danger', message: res.msg, position: 'bottom' });
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    download() {
      downloadResume(this.userId).then(response => {
        // 从响应头中获取文件名
        const contentDisposition = response.headers['content-disposition'];
        let fileName = '简历'; // 默认文件名
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (fileNameMatch.length > 1) {
            fileName = fileNameMatch[1];
          }
        }
        fileName = decodeURI(fileName);

        // 创建一个Blob对象，用于处理文件流
        const blob = new Blob([response.data]);
        // 创建一个临时URL指向这个Blob对象
        const url = window.URL.createObjectURL(blob);
        // 创建一个a标签
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // 设置下载属性及文件名
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 下载完成后，清理临时URL和a标签
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    downloadOne(file) {
      let url = window.location.protocol + '//' + window.location.hostname + file['url'];
      console.log(url)
      window.location.href = url;
    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding: 0 16px 20px;
}

.resume-item {
  font-size: 20px;
  line-height: 24px;
  padding: 24px 8px 12px 8px;
}

.resume-hits {
  color: #969799;
  font-size: 14px;
}

.resume-button {
  font-size: 18px;
  margin-top: 20px;
}

.resume-card {
  margin: 0px 0 10px 0;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

.card-button {
  margin: 20px 10px 10px 10px;
}

/deep/ .van-cell__title {
  min-width: 35%;
}

/deep/ .van-cell__value {
  min-width: 65%;
}
</style>